import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from '@emotion/styled'
import { IHeaderParams } from 'ag-grid-community'
import { NegotiationActions } from 'api'
import { DefaultCellContentWrapper } from '../renderers'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { allBackToStagingNegotiationIdsSelector } from 'selectors/negotiations'
import { Locale, Translation } from 'locale'
import * as constants from 'view/styles/constants'

interface BackToStagingAllNegotiationsButtonProps extends IHeaderParams {
  eligibleNegotiationIds: string[]
  onBackToStaging: (negotiationId: string, ownOrder: boolean) => unknown
}

const mapStateToProps = createStructuredSelector({
  eligibleNegotiationIds: allBackToStagingNegotiationIdsSelector
})

const mapDispatchToProps = {
  onBackToStaging: NegotiationActions.backToStaging
}

const Wrapper = styled(DefaultCellContentWrapper)`
  padding: 0;
`

const TextButtonStyled = styled(TextButton)`
  font-weight: ${constants.FontWeight.Bold};
  font-size: 12px;
  width: 100%;
`

class BackToStagingAllNegotiationsButtonComponent extends React.Component<BackToStagingAllNegotiationsButtonProps> {
  private handleClick = () => {
    const { eligibleNegotiationIds, onBackToStaging } = this.props
    eligibleNegotiationIds.forEach(negotiationId => onBackToStaging(negotiationId, true))
  }

  render() {
    const { eligibleNegotiationIds } = this.props

    if (eligibleNegotiationIds.length === 0) {
      return null
    }

    return (
      <Wrapper>
        <TextButtonStyled type={TextButtonType.Tertiary} onClick={this.handleClick}>
          {Locale.translate(Translation.TC_ACTION_BACK_TO_STAGING_ALL)}
        </TextButtonStyled>
      </Wrapper>
    )
  }

  refresh = () => {
    this.forceUpdate()
    return true
  }
}

export const BackToStagingAllNegotiationsButton = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  BackToStagingAllNegotiationsButtonComponent
)
